import React from 'react'
import { browserHistory } from 'react-router'
import ReactGA from 'react-ga'
import GameClasses from './Game.scss'
import classes from './GameOver.scss'
import JottoDude from './dude.png'
import Bubble from './share_bubble.png'
import Button from '../Button'

export default class GameOver extends React.Component {

  constructor (props) {
    super(props)

    const self: any = this
    self.state = { sending: false, sentRematch: false, timerId: null, challengeId: null }
    self.rematch = self.rematch.bind(self)
    self.sendOrAcceptChallenge = self.sendOrAcceptChallenge.bind(self)
    self.checkChallenge = self.checkChallenge.bind(self)
    self.startRematchTimer = self.startRematchTimer.bind(self)
    self.stopRematchTimer = self.stopRematchTimer.bind(self)
  }

  renderGuess (guess, idx) {
    const { word, matches } = guess
    return (<li key={idx}><h4>{word}</h4><span>{Number.isInteger(matches) && matches}</span></li>)
  }

  rematch () {
    const { mode } = this.props
    if (mode === 'solo') {
      window.location.href = '/game'
    } else {
      this.sendOrAcceptChallenge()
    }
  }

  sendOrAcceptChallenge () {
    const { sending, sentRematch } = this.state
    const { baseUrl, enemyName } = this.props

    if (sending || sentRematch) return
    this.setState({ sending: true })

    fetch(`${baseUrl}/challenges/new`, {
      method: 'POST',
      body: JSON.stringify({ username: enemyName }),
      credentials: 'include',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(res => res.json())
      .then(res => {
        const { result, gameId, challengeId } = res
        this.setState({ sending: false, sentRematch: true })

        if (result === 'ok') {
          if (gameId) {
            window.location.pathname = `/game/${gameId}`
          } else {
            this.setState({ challengeId })
            this.startRematchTimer(challengeId)
          }
        } else {
          alert(res.err || res.message)
        }
      })
  }

  startRematchTimer (challengeId) {
    if (this.state.timerId) return
    const timerId = setInterval(this.checkChallenge, 3000)
    this.setState({ timerId })
  }

  checkChallenge () {
    const { baseUrl } = this.props
    const { challengeId } = this.state

    fetch(`${baseUrl}/challenges/${challengeId}/info`, { credentials: 'include' })
      .then(res => res.json())
      .then(res => {
        const { result, gameId } = res
        this.setState({ sending: false, sentRematch: true })

        if (result === 'ok') {
          if (gameId) {
            window.location.pathname = `/game/${gameId}`
          } else {
            this.startRematchTimer()
          }
        } else if (result === 'stop') {
          this.stopRematchTimer()
        } else {
          this.stopRematchTimer()
          console.log(res.err || res.msg)
        }
      })
  }

  componentDidMount () {
    window.fbAsyncInit = () => {
      FB.XFBML.parse()
    }
    twttr.widgets.load()
  }

  componentWillUnmount () {
    this.stopRematchTimer()
  }

  stopRematchTimer () {
    const { timerId } = this.state
    if (timerId) {
      clearInterval(timerId)
    }
  }

  renderFacebookIcon () {
    return (
      <iframe src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Fwww.mrjotto.com%2F&layout=button&size=small&mobile_iframe=true&appId=1670598623254277&width=59&height=20" width="59" height="20" style={{border:'none', overflow:'hidden', marginRight: '10px'}} scrolling="no" frameBorder="0" allowTransparency="true"></iframe>
    )
  }

  renderTwitterIcon () {
    const twitterText = 'Check%20out%20this%20fun%20game%20I%20just%20played!'

    return (<a className="twitter-share-button"
      href={`https://twitter.com/intent/tweet?text=${twitterText}&url=https://www.mrjotto.com/`}>
    Tweet</a>)
  }


  render () {
    const { target, mode, guesses, score, enemyName, enemyGuesses, enemyScore } = this.props
    const guessCount = guesses.length
    const { sending, sentRematch } = this.state
    const enemyGuessCount = enemyGuesses && enemyGuesses.length
    const winner = score >= enemyScore
    const rematchText = mode == 'multi' ? (sending && 'Sending...') || (sentRematch && 'Challenge Sent!') || 'Rematch!' : 'Play again!'
    const btnClasses = [classes.rematchBtn, (sending || sentRematch) && classes.disabled].join(' ')

    return (
      <div className={[classes.mainBox, mode == 'multi' && classes.multi].join(' ')}>
        <div className={classes.overlay} />
        <div className={classes.content}>
          <div className={classes.wordBox}>
            <h2>{target}</h2>
          </div>
          <div>
            <h3 className={classes.meName}>Me</h3>
            <h3 className={[classes.guessCount, mode == 'multi' && classes.multi].join(' ')}>{guessCount}</h3>
            <ul className={[classes.guessBox, GameClasses.guesses, mode == 'multi' && classes.multi, winner && classes.winner].join(' ')}>
              {[...guesses].map(this.renderGuess.bind(this))}
            </ul>
            {mode == 'multi' && <div>
            <h3 className={classes.enemyName}>{enemyName}</h3>
            <h3 className={classes.enemyGuessCount}>{enemyGuessCount}</h3>
            <ul className={[classes.guessBox, GameClasses.guesses, mode == 'multi' && classes.multi, classes.second, !winner && classes.winner].join(' ')}>
              {[...enemyGuesses].map(this.renderGuess.bind(this))}
            </ul></div>}
            <div className={[classes.scoreBox, mode == 'multi' && classes.multi].join(' ')}>
              <h4>Score</h4>
              <span className={winner && classes.winner}>{score}</span>
              {mode == 'multi' && <span className={!winner && classes.winner}>{enemyScore}</span>}
            </div>
            <img className={classes.jotto} src={JottoDude} />
            <div className={[classes.shareBubble, mode == 'multi' && classes.multi].join(' ')}>
              <img src={Bubble} />
              <p>Share this game with your friends!</p>
            </div>
            <div className={[classes.shareBox, mode == 'multi' && classes.multi].join(' ')}>
              {this.renderFacebookIcon()}
              {this.renderTwitterIcon()}
            </div>
            <Button className={btnClasses} onClick={this.rematch} value={rematchText} />
          </div>
        </div>
      </div>
    )
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/Game/GameOver.js
 **/